/************************************** THIRD-PARTY MODULES ***************************************/
import React from 'react';
import cn from 'classnames';

import RCSwitchSlider from 'rc-switch';
import {isString, isStringOrNumber} from 'mad-utils/lib/shared';

/********************************************* EXPORT *********************************************/
/**
 * Show the current setting as a right<->left slider component row
 * Can optionally include a [title] string to display to the left of the slider
 *
 * @param {boolean} isSelected If true, check the box
 * @param {Function} setSlider Run this EventHandler on slider value change (click)
 * @param {string} title Title to display beside the switch component
 * @param {string} switchClassNames CSS classes to add to slider itself [Default: ``]
 * @param {number} height Wrapping block's height [Default: 50]
 * @param {string} rowClassNames CSS classes to add to wrapping row
 * @param {string} id DOM 'id' attribute to add to the outer slider DOM element
 */
export const CISwitch = ({
    isSelected,
    setSlider,
    title,
    switchClassNames,
    height,
    rowClassNames,
    fontSize,
    id,
}: {
    isSelected: boolean;
    setSlider: EventHandler;
    title?: string;
    switchClassNames?: string;
    height?: string | number;
    rowClassNames?: string;
    fontSize?: string | number;
    id?: string;
}) => {
    /**
     * Build the switch, for use in either condition (with or without title)
     */
    const rcSwitch = (
        <RCSwitchSlider
            id={id || null}
            checked={isSelected}
            onChange={setSlider}
            className={switchClassNames || ``}
        />
    );

    // If title given, create a title row style switch component
    return isString(title) ? (
        <div
            className={cn(`flex row space-between ai-center`, rowClassNames)}
            style={{height: isStringOrNumber(height) ? height : 50}}
        >
            <div
                className={cn(`helvetica-neue-light fw-500`)}
                style={{fontSize: isStringOrNumber(fontSize) ? fontSize : 18}}
            >
                {title}
            </div>
            <div>{rcSwitch}</div>
        </div>
    ) : (
        // If no title given, create only the switch w/ no associated title or wrapper
        rcSwitch
    );
};

CISwitch.displayName = `CISwitch`;
